(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyCompileHtml', gmyCompileHtml);

  function gmyCompileHtml(
    $compile
  ) {
    'ngInject';

    return {
      restrict: 'A',
      link(scope, element, attrs) {
        attrs.$observe('gmyCompileHtml', (newVal) => {
          element.html(newVal);
          $compile(element.contents())(scope);
        });
      },
    };
  }
})();
